import React, {useEffect, useCallback, useState} from "react";
import {getBetterCryptoSuggestion, getTop7DayPerformerGainerLooserAPI} from "../../../../apihelper/profile";
import {Skeleton, useMediaQuery, Button} from "@mui/material";
import json2mq from "json2mq";
import {useNavigate} from "react-router-dom";
import TableHook from "../../../account/profile/tables/TableHook";
import TableCardHook from "../../../account/profile/tables/TableCardHook";
import {VolunteerActivismOutlined} from "@mui/icons-material";
import {getPortfolioData} from "../../../../apihelper/portfolio";
import Box from "@mui/material/Box";

export const UnderperformerCurrently = (props = {}) => {
    const {cryptoList, portfolioId} = props;
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [loading, setLoading] = useState(false);
    const [my7DaysPortfolio, setMy7DaysPortfolio] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    // const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const [selectedCrypto, setSelectedCrypto] = useState();
    const [portfolio_id, setPortfolio_id] = useState();
    useEffect(() => {
        setPortfolio_id(portfolioId);
    }, [portfolioId]);
    const [sortType, setSortType] = useState("fd_asc");
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [isPredictionDataLoaded, setIsPredictionDataLoaded] = useState(false);

    const fetchPortfolioCrypto = useCallback(() => {
        if (!userData || !portfolio_id) {
            return;
        }
        setLoading(true);
        const data = {
            portfolio_type_id: portfolio_id,
            user_id: userData.user_id,
            Token: userData.token,
        };
        console.log("Calling api");
        getPortfolioData(data)
        .then((res) => {
            const slugArray = res.data.map((item) => item.slug);
            console.log("slugArray", res.data);
            setSelectedCrypto(slugArray);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        if (userData || portfolio_id) {
            fetchPortfolioCrypto();
        }
    }, [fetchPortfolioCrypto]);

    const fetchData = useCallback(() => {
        console.log("selectedCrypto", selectedCrypto);
        if (!portfolio_id) {
            return;
        }
        setLoading(true);
        const limit = 1;
        getBetterCryptoSuggestion(selectedCrypto, portfolio_id, limit, userData)
        .then((res) => {
            setMy7DaysPortfolio(res);
            setLoading(false);
        })
        .catch((error) => {
            console.error("Fetch data error:", error);
            setLoading(false);
        });
    }, [portfolio_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    

    const fetchCryptoData = async () => {
    setLoading(true); // Start loading
    try {
        const formData = new URLSearchParams();
        formData.append("portfolioName", portfolio_id);
        formData.append("sortType", sortType);
        formData.append("user_id", userData.user_id);

        const response = await fetch(
            "https://crowdwisdom.live/wp-json/api/v1/showCryptoRecommendationsFutureData2",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded", // simple header
                },
                body: formData.toString(), // properly encoded body
            }
        );

        const result = await response.json();
        console.log("recommendations:", result.response);

        if (result.code === "200" || result.code === "500") {
            setData(result.response); // Set the fetched data
        } else {
            setError(result.message); // Handle error code
        }
    } catch (err) {
        setError("An error occurred while fetching data.");
    } finally {
        setLoading(false); // End loading
    }
};


    useEffect(() => {
        fetchCryptoData(); // Fetch data when component mounts
    }, [portfolio_id]);
    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };
    const sortedData1 = data;
        const [ignoredRows, setIgnoredRows] = useState([]); // Tracks ignored rows
        const [displayData, setDisplayData] = useState([]); // Displayed cryptos
        const [queueData, setQueueData] = useState([]); // Cryptos queued for later
    
        // Organize batches based on numeric prefixes in crypto symbols
        const organizeBatches = (data) => {
            const batches = {};
    
            data.forEach((crypto) => {
                const prefix = crypto.crypto_symbol.match(/^\d+/)?.[0];
                if (prefix) {
                    if (!batches[prefix]) {
                        batches[prefix] = [];
                    }
                    batches[prefix].push(crypto);
                }
            });
    
            return batches;
        };
    
        // Round-robin display logic for batches
        const roundRobinDisplay = (data) => {
            const batches = organizeBatches(data);
            let displayOrder = [];
            let batchQueue = [];
    
            Object.keys(batches).forEach((batchPrefix) => {
                const batch = batches[batchPrefix];
                displayOrder.push(...batch.slice(0, 2)); // First 2 cryptos per batch
                batchQueue.push(...batch.slice(2)); // Remaining cryptos
            });
    
            return {displayOrder, batchQueue};
        };
    
        // Effect to recalculate display data when sortedData1 changes
        useEffect(() => {
            if (sortedData1 && sortedData1.length > 0) {
                const {displayOrder, batchQueue} = roundRobinDisplay(sortedData1);
                setDisplayData(displayOrder);
                setQueueData(batchQueue);
                setIsPredictionDataLoaded(true);
            } else {
                setIsPredictionDataLoaded(false);
            }
        }, [sortedData1]);
    
        // Handle ignore click and update display data dynamically
        const handleIgnoreClick = (index) => {
            setIgnoredRows((prevIgnored) => [...prevIgnored, displayData[index].crypto_symbol]);
    
            setDisplayData((prevDisplay) => {
                const updatedDisplay = prevDisplay.filter(
                    (_, idx) => idx !== index // Remove the ignored row from display
                );
    
                const ignoredCrypto = prevDisplay[index];
                const batchPrefix = ignoredCrypto.crypto_symbol.match(/^\d+/)?.[0];
                const nextInQueue = queueData.find((data) => data.crypto_symbol.startsWith(batchPrefix));
    
                if (nextInQueue) {
                    setQueueData((prevQueue) =>
                        prevQueue.filter((data) => data.crypto_symbol !== nextInQueue.crypto_symbol)
                    );
                    return [...updatedDisplay, nextInQueue];
                }
    
                return updatedDisplay;
            });
        };
    
        // Check if all rows are ignored
        const allRowsIgnored = displayData.every((crypto) => ignoredRows.includes(crypto.crypto_symbol));

    const tabData = displayData?.map((portfolio, index) => [
    // Column 1 - Crypto
    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
  {/* 1. Gradient Logo + Slug Box */}
  <div
    style={{
      padding: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontWeight: "bold",
      fontSize: "12px",
      color: "#333",
      borderRadius: "20px",
      width: "205px",
      height: "62px",
      background: "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        width={38.77}
        height={37}
        style={{
          borderRadius: "19px",
          border: "2px solid black",
          marginRight: "10px",
          display: "block",
        }}
        src={portfolio.target_logo}
        
      />
      <div
        className="btcParent"
        style={{
          fontWeight: "700",
          fontSize: "20px",
          lineHeight: "1",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        {portfolio.crypto_symbol.split("-")[1]}
      </div>
    </div>
  </div>

  {/* 2. Category Box */}
  {portfolio["category"] && (
    <Box
      sx={{
        border: "1px solid #1877F2",
        fontSize: "12px",
        borderRadius: "20px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        padding: "6px 18px",
        color: "#1877F2",
        fontWeight: "500",
        whiteSpace: "nowrap",
        height: "fit-content",
        minWidth:"25%"
      }}
    >
      {portfolio.category}
    </Box>
  )}
  </div>,

    // Column 2 - Last 7 Days for symbol
    portfolio.symbol_sevend_change != null && !isNaN(Number(portfolio.symbol_sevend_change)) ? (
        <span>
            {Number.isInteger(Number(portfolio.symbol_sevend_change))
                ? `${Number(portfolio.symbol_sevend_change)}%`
                : `${Number(portfolio.symbol_sevend_change).toFixed(1)}%`}
        </span>
    ) : (
        "-"
    ),

    // Column 3 - Best performer in category
    <div
    style={{
      padding: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontWeight: "bold",
      fontSize: "12px",
      color: "#333",
      borderRadius: "20px",
      width: "205px",
      height: "62px",
      background: "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      marginLeft:"20%"
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        width={38.77}
        height={37}
        style={{
          borderRadius: "19px",
          border: "2px solid black",
          marginRight: "10px",
          display: "block",
        }}
        src={portfolio.symbol_logo}
        
      />
      <div
        className="btcParent"
        style={{
          fontWeight: "700",
          fontSize: "20px",
          lineHeight: "1",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        {portfolio.crypto_symbol.split("-")[3]}
      </div>
    </div>
  </div>,

    // Column 4 - Last 7 Days for target
    portfolio.target_sevend_change != null && !isNaN(Number(portfolio.target_sevend_change)) ? (
        <span>
            {Number.isInteger(Number(portfolio.target_sevend_change))
                ? `${Number(portfolio.target_sevend_change)}%`
                : `${Number(portfolio.target_sevend_change).toFixed(1)}%`}
        </span>
    ) : (
        "-"
    ),

    // Column 5 - Ignore button
    <Button onClick={() => handleIgnoreClick(index)} key={`btn-${portfolio.crypto_symbol}`}>
        <img
            width="20px"
            src={window.constants.asset_path + "/images/trash.svg"}
            alt="Ignore"
        />
    </Button>
]);
const tableHeader = [
    { label: "Crypto", key: "crypto", sorting: true },
    { label: "Last 7 Days", key: "seven_day", sorting: true },
    { label: "Best Performer In Category", key: "crypto", sorting: true },
    { label: "Last 7 Days", key: "seven_day", sorting: true },
    { label: " ", key: "ignore", sorting: false }
];
  return (
        <div className="section-2">
            <TableHook header={tableHeader} tableData={tabData} loading={loading} />

            {/* for mobile */}
            {displayData?.map((portfolio, index) => (
                <div className="is-mobile" key={index} style={{ marginBottom: "50px" }}>
                    <div
                        className="sm-table-card"
                        style={{
                            background:
                                "linear-gradient(89.97deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0) 123.27%)",
                        }}
                    >
                        <div className="sm-table-heading">
    <div className="d-flex justify-content-between align-items-center">
        {/* Left section with logo, name and category */}
        <div className="d-flex align-items-center">
            <h6 className="mb-0 d-flex align-items-center">
                <img
                    alt="image"
                    src={portfolio.target_logo}
                    className="me-2 analysis-icon"
                    style={{ width: 30, height: 30, borderRadius: 19 }}
                />
                {portfolio.symbol}{portfolio.crypto_symbol.split("-")[1]}
                <span
                    style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" }}
                    className="ms-4 text-primary border border-primary rounded-pill bg-white text-sm px-2 py-1 fs-6"
                >
                    {portfolio.category}
                </span>
            </h6>
        </div>

        {/* Right section with trash button */}
        <div>
            <Button onClick={() => handleIgnoreClick(index)}>
                <img
                    width="20px"
                    src={window.constants.asset_path + "/images/trash.svg"}
                    alt="Ignore"
                />
            </Button>
        </div>
    </div>
</div>

                        <div className="sm-table-body-custom">
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b>Last 7 Days:</b>
                                <span className="ms-1">
                                    {portfolio.symbol_sevend_change != null && !isNaN(Number(portfolio.symbol_sevend_change))
                                        ? Number.isInteger(Number(portfolio.symbol_sevend_change))
                                            ? `${Number(portfolio.symbol_sevend_change)}%`
                                            : `${Number(portfolio.symbol_sevend_change).toFixed(1)}%`
                                        : "-"}
                                </span>
                            </span>
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b className="my-auto">Best Performer In the Category:</b>
                                <span
                                    className="ms-1 my-auto"
                                    style={{
                                        border: "1px solid rgba(24, 119, 242, 1)",
                                        borderRadius: "2rem",
                                        fontWeight: "700",
                                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                        padding: "4px 10px",
                                        background: "white",
                                        minWidth: "none",
                                        display: "flex",
                                    }}
                                >
                                    <img
                                        src={portfolio.symbol_logo}
                                        className="crypto_icon"
                                        alt={portfolio.crypto_symbol.split("-")[3]}
                                    />
                                    <span className="tab-text ms-2">{portfolio.crypto_symbol.split("-")[3]}</span>
                                </span>
                            </span>
                            <span className="d-flex flex-grow-1 mb-2 my-auto">
                                <b>Last 7 Days:</b>
                                <span className="ms-1">
                                    {portfolio.target_sevend_change != null &&
                                    !isNaN(Number(portfolio.target_sevend_change))
                                        ? Number.isInteger(Number(portfolio.target_sevend_change))
                                            ? `${Number(portfolio.target_sevend_change)}%`
                                            : `${Number(portfolio.target_sevend_change).toFixed(1)}%`
                                        : "-"}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            ))}
            {loading &&
                Array.from({length: 3}).map((_, index) => (
                    <TableCardHook
                        key={index}
                        header={{
                            name: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            icon: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} width={40} />,
                        }}
                        body={[
                            {key: "Price", value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />},
                            {
                                key: "Last 7 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                        ]}
                        footer={[{label: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />}]}
                        loading={loading}
                    />
                ))}

            
        </div>
    );
};
